import { render, staticRenderFns } from "./householdDetail.vue?vue&type=template&id=2e1021c2&scoped=true&"
import script from "./householdDetail.vue?vue&type=script&lang=js&"
export * from "./householdDetail.vue?vue&type=script&lang=js&"
import style0 from "./householdDetail.vue?vue&type=style&index=0&id=2e1021c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1021c2",
  null
  
)

export default component.exports